import { render, staticRenderFns } from "./PublicationAdd.vue?vue&type=template&id=4473c94c&"
import script from "./PublicationAdd.vue?vue&type=script&lang=js&"
export * from "./PublicationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports